<template>
  <div></div>
</template>
<script>
export default {
  created() {
    let self = this;
    // this.$store.dispatch("user/isLogin", function(result) {
    //   if (result == false) {
    //     self.$router.push("/login");
    //   }
    // });
  }
};
</script>


// WEBPACK FOOTER //
// src/views/layout/components/Authority.vue